import React, { PureComponent } from 'react';
import { MdLoaderTheme } from '../../common/Loading';

class OrderHistoryLoader extends PureComponent {
  render() {
    return (
      <div className="row">
        <div className="loading-more-items load-more">
          <MdLoaderTheme size={30} />
        </div>
      </div>
    );
  }
}

export default OrderHistoryLoader;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryLoader.jsx